import {
  CLAIM_REWARD_REQUEST,
  CLAIM_REWARD_SUCCESS,
  CLAIM_REWARD_FAIL,
  CLAIM_REWARD_LOADING,
  CLEAR_CLAIM_REWARD_SUCCESS,
  GET_REWARD_STATUS_REQUEST,
  GET_REWARD_STATUS_SUCCESS,
  GET_REWARD_STATUS_FAIL,
  GET_REWARD_STATUS_LOADING,
} from "../types";

// Claim Reward Actions
export const claimRewardRequest = (prop) => {
  return {
    type: CLAIM_REWARD_REQUEST,
    payload: prop,
  };
};

export const claimRewardSuccess = (prop) => {
  return {
    type: CLAIM_REWARD_SUCCESS,
    payload: prop,
  };
};

export const clearClaimRewardSuccess = (prop) => {
  return {
    type: CLEAR_CLAIM_REWARD_SUCCESS,
    payload: prop,
  };
};

export const claimRewardFailure = (errors) => {
  return {
    type: CLAIM_REWARD_FAIL,
    payload: { errors },
  };
};

export const claimRewardLoading = (loading) => {
  return {
    type: CLAIM_REWARD_LOADING,
    payload: loading,
  };
};

// Get Reward Status Actions
export const getRewardStatusRequest = (prop) => {
  return {
    type: GET_REWARD_STATUS_REQUEST,
    payload: prop,
  };
};

export const getRewardStatusSuccess = (prop) => {
  return {
    type: GET_REWARD_STATUS_SUCCESS,
    payload: prop,
  };
};

export const getRewardStatusFailure = (errors) => {
  return {
    type: GET_REWARD_STATUS_FAIL,
    payload: { errors },
  };
};

export const getRewardStatusLoading = (loading) => {
  return {
    type: GET_REWARD_STATUS_LOADING,
    payload: loading,
  };
};
